
export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/3a74c0b4295aab66bf1c55ff332b74b8.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 text-center text-white">
        <div className="mb-8">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            <span style={{ fontFamily: '"Pacifico", serif' }}>Edgeway Auto</span>
          </h1>
          <p className="text-2xl md:text-3xl font-light mb-8">
            Wholesale Automotive Solutions
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto mb-12">
          <p className="text-xl md:text-2xl leading-relaxed mb-8">
            Connecting dealers, investors, and industry professionals with quality vehicles at competitive prices. 
            We streamline the wholesale process with transparency, efficiency, and profitability.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
            View Inventory
          </button>
          <button className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
            Partner With Us
          </button>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">500+</div>
            <p className="text-lg">Vehicles Monthly</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">150+</div>
            <p className="text-lg">Dealer Partners</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">15+</div>
            <p className="text-lg">Years Experience</p>
          </div>
        </div>
      </div>
    </section>
  );
}
